import React from 'react';
import Layout from '../Layouts/mainLayout';
import Header from '../components/headerCategory';

const Category = () => {
  return (
    <Layout header={Header}>
    </Layout>
  );
};

export default Category;